"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      borderRadius: '32px',
      textTransform: 'none'
    }
  };
});
/**
 * A Generic Button that supports different Colors and Styles -> Supports properties from: https://material-ui.com/api/button/
 */

function Button(_ref) {
  var id = _ref.id,
      onClick = _ref.onClick,
      variant = _ref.variant,
      children = _ref.children,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["id", "onClick", "variant", "children", "color"]);

  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    id: id,
    variant: variant,
    color: color,
    classes: classes,
    onClick: onClick
  }, props), children);
}

Button.defaultProps = {
  color: 'primary',
  variant: 'outlined',
  fullWidth: false,
  size: 'medium'
};